import React from "react";
import imgVirgen from "../assets/img/virgen.jpg";
import EsquinerosArriba from "./EsquinerosArriba";
import EsquinerosAbajo from "./EsquinerosAbajo";
import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

const titulos = [
  { path: "/mensajes-virgen/es", titulo: "Mensajes que la Inmaculada Madre del Divino Corazón Eucarístico de Jesús está dando en la ciudad de Salta, República Argentina, desde el   año 1990 a la Sra. María Livia Galliano de Obeid" },
  { path: "/mensajes-virgen/en", titulo: "Messages that the Immaculate Mother of the Divine Eucharistic Heart of Jesus is giving in the city of Salta, Argentina, since 1990 to Mrs. María Livia Galliano de Obeid" },
  { path: "/mensajes-virgen/fr", titulo: "Messages que la Mère Immaculée du Divin Cœur Eucharistique de Jésus donne dans la ville de Salta, République Argentine, depuis 1990 à Mme María Livia Galliano de Obeid" },
  { path: "/mensajes-virgen/ger", titulo: "Botschaften die die Unbefleckte Mutter vom Göttlichen Eucharistischen Herzen Jesu seit 1990 in der Stadt Salta - Republik Argentinien - an Frau María Livia Galliano de Obeid überbracht hat" },
];

export default function HeaderMensajesVirgen(props) {
  const [fontSizes, setFontSizes] = useState(16);
  let location = useLocation();
  const [intro, setIntro] = useState("");

  const aumentar = () => {
    if (fontSizes < 22) {
      const newSize = fontSizes + 2;
      setFontSizes(newSize);
    }
  };
  const restar = () => {
    if (fontSizes > 12) {
      const newSize = fontSizes - 2;
      setFontSizes(newSize);
    }
  };

  useEffect(() => {
    for (let i = 0; i < titulos.length; i++) {
      const element = titulos[i];
      if (element.path === location.pathname) {
        setIntro(element.titulo);
      }
    }
  }, [location]);

  return (
    <>
      <div className="container pt-3 px-5">
        <div className="row">
          <img
            src={imgVirgen}
            alt="Estampa de La Inmaculada Madre del Divino Corazón Eucarístico de Jesús"
            className="img-fluid pt-5"
          />
        </div>
      </div>
      <div
        className="px-5 mt-4 py-2 banner-mensajes col-12 text-center"
        id="1990"
      >
        <p className="text-dark">
          {intro}
        </p>
      </div>
      <div id="mensajes-body" className={"font-" + fontSizes}>
        <EsquinerosArriba />
        <div className="container px-md-4" id="1990">
          {props.children}
        </div>
        <EsquinerosAbajo />
      </div>
      <div className="btn-fonts d-flex">
        <button onClick={aumentar}>
          <strong>A</strong>
        </button>
        <button onClick={restar} style={{ fontSize: "1.1rem" }}>
          <strong>A</strong>
        </button>
      </div>
    </>
  );
}
